// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var AllocationKey;
(function (AllocationKey) {
    AllocationKey["Nav"] = "nav";
    AllocationKey["Commitment"] = "commitment";
    AllocationKey["Hybrid"] = "hybrid";
    AllocationKey["GrossNav"] = "grossNav";
    AllocationKey["GrossNavHybrid"] = "grossNavHybrid";
})(AllocationKey || (AllocationKey = {}));
export function AllocationKeyFromJSON(json) {
    return json;
}
export function AllocationKeyToJSON(value) {
    return value;
}
